import React, { Fragment, useEffect } from "react";
import * as s from "./ProjectTimeTracker.style";
import * as Yup from "yup";
import FormikControl from "../../../../components/shared/inputs/FormikControl";
import { Formik, Form } from "formik";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as action from "../../../../store/actions/index";

function diff(startTime, endTime) {
  var start = startTime.split(":");
  var end = endTime.split(":");
  var startDate = new Date(0, 0, 0, start[0], start[1], 0);
  var endDate = new Date(0, 0, 0, end[0], end[1], 0);
  var diff = endDate.getTime() - startDate.getTime();
  var hours = Math.floor(diff / 1000 / 60 / 60);
  diff -= hours * 1000 * 60 * 60;
  var minutes = Math.floor(diff / 1000 / 60);

  return (
    (hours < 9 ? "0" : "") + hours + "." + (minutes < 9 ? "0" : "") + minutes
  );
}

function format(date) {
  const [yy, mm, dd] = date.split(/-/g);
  return `${dd}/${mm}/${yy}`;
}

const ProjectTimeTracker = (props) => {
  let { clientId } = useParams();
  let { projectId } = useParams();
  let history = useHistory();
  let { projectName } = useParams();
  let dispatch = useDispatch();

  const clientLoading = useSelector((state) => state.forManageAccount.loading);
  const clientData = useSelector((state) => state.forManageAccount.accountData);
  useEffect(() => {
    dispatch(action.fetchClientProjects(clientId, 1, 10));
    dispatch(action.fetchAccountAdmin(clientId));
    dispatch(action.fetchClientProjectPeriod(projectId));
  }, []);

  const initialValues = {
    date: "",
    startTime: "",
    endTime: "",

    description: "",
  };

  const validationSchema = Yup.object({
    date: Yup.string().required("Required"),
    startTime: Yup.string().required("Required"),
    endTime: Yup.string().required("Required"),
    // hours: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  let projects = useSelector((state) => state.forProjects.projects);

  // console.log(projects)

  let createPeriodLoading = useSelector(
    (state) => state.forProjectPeriod.loading
  );
  // console.log(createPeriodLoading);
  // console.log(projectId)

  const onSubmit = (values) => {
    if (values.startTime && values.endTime) {
      const hours = diff(values.startTime, values.endTime);
      // console.log("Form values", values.startTime, values.endTime);
      dispatch(
        action.createClientProjectPeriod(
          projectId,
          {
            hours: +hours,
            date: `${format(values.date)}`,
            description: values.description,
          }
          // () => history.goBack()
        )
      );
    }
  };
  return (
    <s.ScreenContainer>
      {clientLoading === false ? (
        <Fragment>
          <s.H1>
            Time Tracker -{`${clientData.first_name} ${clientData.last_name}`} -{" "}
            {projectName}
          </s.H1>
          <s.Container>
            <s.Div1>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <s.InputContainer>
                        <FormikControl
                          control="input"
                          // control='chakraInput'
                          type="date"
                          name="date"
                        />
                      </s.InputContainer>
                      <s.InputContainer>
                        <FormikControl
                          control="input"
                          // control='chakraInput'
                          type="time"
                          name="startTime"
                        />
                      </s.InputContainer>
                      <s.InputContainer>
                        <FormikControl
                          control="input"
                          // control='chakraInput'
                          type="time"
                          name="endTime"
                        />
                      </s.InputContainer>
                      <s.H3>Description:</s.H3>
                      <s.InputContainer>
                        <FormikControl
                          control="input"
                          // control='chakraInput'
                          type="textarea"
                          name="description"
                        />
                      </s.InputContainer>
                      <s.Btn
                        type="submit"
                        disabled={!formik.isValid}
                        onClick={onSubmit}
                      >
                        Submit
                      </s.Btn>
                    </Form>
                  );
                }}
              </Formik>
            </s.Div1>
            <s.Div2>
              <s.H1>Recorded time entries:</s.H1>
              <s.Data>
                <table>
                  <tr>
                    <th>Date</th>
                    <th>Hours Spent </th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>7/26/21</td>
                    <td>3</td>
                    <td>Design work..</td>
                  </tr>
                  <tr>
                    <td>7/26/21</td>
                    <td>3</td>
                    <td>Design work..</td>
                  </tr>
                  <tr>
                    <td>7/26/21</td>
                    <td>3</td>
                    <td>Design work..</td>
                  </tr>
                  <tr>
                    <td>7/26/21</td>
                    <td>3</td>
                    <td>Design work..</td>
                  </tr>
                  <tr>
                    <td>7/26/21</td>
                    <td>3</td>
                    <td>Design work..</td>
                  </tr>
                </table>
              </s.Data>
            </s.Div2>
          </s.Container>
        </Fragment>
      ) : null}
    </s.ScreenContainer>
  );
};

export default ProjectTimeTracker;
